import SubstrateClassStandardSelection, {
  keyOfSelectionStandard,
  labelOfSelectionStandard,
} from "./SubstrateClassStandardSelection";
import SubstrateClassTapeSelection, { keyOfSelectionTape, labelOfSelectionTape } from "./SubstrateClassTapeSelection";

export type SubstrateClassSelection = SubstrateClassStandardSelection | SubstrateClassTapeSelection;

export const labelOfSubstrateClassSelection = (selection: SubstrateClassSelection): string => {
  switch (selection.kind) {
    case "standard":
      return labelOfSelectionStandard(selection);
    case "tape":
      return labelOfSelectionTape(selection);
    default:
      return "";
  }
};

export const keyOfSubstrateClassSelection = (selection: SubstrateClassSelection, index: number): string => {
  switch (selection.kind) {
    case "standard":
      return `${keyOfSelectionStandard(selection)}_${index}`;
    case "tape":
      return `${keyOfSelectionTape(selection)}_${index}`;
    default:
      return "";
  }
};
